/**
 * Numera's three-tile brand mark — mint, blue, lime (`--brand-dot-1/2/3` in
 * globals.css). Shared by the app header (beside the Numera wordmark) and
 * the sidebar (beside "Clockwise", and alone in the collapsed icon rail) so
 * the same three squares read as one mark wherever they appear.
 *
 * Squares rather than an imported SVG logo: it's three divs, it scales with
 * whatever sits next to it, and it survives into the collapsed rail as the
 * brand glyph with no separate asset.
 */
export function BrandDots() {
  return (
    <span className="flex shrink-0 items-center gap-1" aria-hidden="true">
      <i className="block size-[11px] rounded-[4px] bg-[var(--brand-dot-1)]" />
      <i className="block size-[11px] rounded-[4px] bg-[var(--brand-dot-2)]" />
      <i className="block size-[11px] rounded-[4px] bg-[var(--brand-dot-3)]" />
    </span>
  );
}
